import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { useState, useEffect } from 'react';
import { useSpring } from 'react-spring/web.cjs';
import useHiddenProps from './useHiddenProps.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var growTo = function growTo(from, to) {
  return [{
    opacity: 1,
    transform: "scale(".concat(to, ")")
  }, {
    opacity: 0,
    transform: "scale(".concat(from, ")")
  }];
};

function useHiddenTransition(_ref) {
  var _ref$animationState = _ref.animationState,
      animationState = _ref$animationState === void 0 ? growTo(0, 1) : _ref$animationState,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 150 : _ref$duration,
      otherProps = _objectWithoutProperties(_ref, ["animationState", "visible", "duration"]);

  var _useHiddenProps = useHiddenProps({
    visible: visible
  }),
      hiddenProps = _objectWithoutProperties(_useHiddenProps, ["hidden"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      resting = _useState2[0],
      setResting = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      destroyed = _useState4[0],
      setDestroyed = _useState4[1];

  var _useSpring = useSpring(function () {
    return _objectSpread(_objectSpread({}, animationState[0]), {}, {
      config: {
        duration: duration
      },
      onStart: function onStart() {
        setResting(false);
        setDestroyed(false);
      },
      immediate: !visible,
      onRest: function onRest() {
        return setResting(true);
      }
    });
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      animationStyles = _useSpring2[0],
      set = _useSpring2[1];

  useEffect(function () {
    set(visible ? _objectSpread(_objectSpread({}, animationState[0]), {}, {
      immediate: false
    }) : _objectSpread({}, animationState[1]));
  }, [visible]);
  useEffect(function () {
    if (!visible && resting) setDestroyed(true);
  }, [resting]); // element props

  return _objectSpread(_objectSpread(_objectSpread({}, otherProps), hiddenProps), {}, {
    style: _objectSpread(_objectSpread({}, otherProps.style), {}, {
      pointerEvents: !visible && 'none'
    }, animationStyles),
    destroyed: destroyed || undefined
  });
}

export default useHiddenTransition;
//# sourceMappingURL=useHiddenTransition.js.map
